export default function TestimonialCard({data = {}}) {

    const {career = "", rate = 1, author = "", testimonial = ""} = data || {};

    return (
        <div
            className="rounded-tr-3xl rounded-br-[2.688rem] rounded-l-[2.688rem] bg-pol-light pt-6 px-4 lg:pl-6 lg:pr-7 pb-[4.375rem] lg:pb-[1.875rem] w-full">
            <div className="flex items-center justify-between">
                <i className="icon-filled-quotation text-pol-blue text-[1.4rem]"/>
                <div className="flex gap-x-1">
                    {Array.from(Array(5), (e, i) => (
                        <i key={i} className={`${rate >= i+1 ? "icon-filled-star" : "icon-star"} text-pol-orange`} />
                    ))}
                </div>
            </div>
            <p className="mt-9 text-pol-gray-600 font-semibold text-sm lg:text-base">{career}</p>
            <p className="mt-4 lg:mt-[1.125rem] text-pol-dark font-bold text-lg lg:text-xl">{author}</p>
            <p className="mt-3.5 lg:mt-[1.75rem] text-pol-gray-600 text-justify leading-[170%] lg:limit-line-5">
                {testimonial}
            </p>
        </div>
    )
}
